<template>
  <a-dialog v-model="isOpen" scrollable persistent max-width="650px">
    <v-card flat>
      <v-toolbar color="primaryLight1" dark height="50px">
        <span>{{ $t("statistics.hSetParameter") }}</span>
        <v-spacer></v-spacer>
        <CloseIcon @click="close()" />
      </v-toolbar>

      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-form
            ref="refAttendanceForm"
            v-model="validDate"
            lazy-validation
            style="display: contents"
          >
            <v-col cols="12">
              <v-row no-gutters>
                <v-col cols="3" class="text-right mr-3 mt-2">
                  {{ $t("search.startDate") }}:
                </v-col>
                <v-col cols="8">
                  <v-menu
                    v-model="calmenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="dateField"
                        ref="reffromdaterange"
                        v-model="formatStartDate"
                        append-icon="mdi-calendar"
                        single-line
                        dense
                        :label="`${$t('search.startDate')} *`"
                        :placeholder="`${$t('search.startDate')} *`"
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        required
                        :rules="startDateRule"
                        outlined
                        @click:append="calmenu = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="topicFilterForm.startDate"
                      :max="currentDate"
                      :locale="selectedLang"
                      color="appMenu lighten-1"
                      @input="calmenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters>
                <v-col cols="3" class="text-right mr-3 mt-2">
                  {{ $t("search.endDate") }}:
                </v-col>
                <v-col cols="8">
                  <v-menu
                    v-model="calmenu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="dateField"
                        ref="reffromdaterange"
                        v-model="formatEndDate"
                        append-icon="mdi-calendar"
                        single-line
                        dense
                        :label="`${$t('search.endDate')} *`"
                        :placeholder="`${$t('search.endDate')} *`"
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        required
                        :rules="endDateRule"
                        outlined
                        @click:append="calmenu2 = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="topicFilterForm.endDate"
                      :min="topicFilterForm.startDate"
                      :locale="selectedLang"
                      color="appMenu lighten-1"
                      @input="calmenu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters class="">
                <v-col cols="3" class="text-right mr-3 mt-2">
                  {{ $t("agenda.lblMeetingType") }}:
                </v-col>
                <v-col cols="8">
                  <v-select
                    class="selectField"
                    v-model="topicFilterForm.meetingType"
                    :items="meetingTypesList"
                    :label="$t('agenda.lblMeetingType')"
                    :placeholder="$t('agenda.lblMeetingType')"
                    single-line
                    dense
                    multiple
                    :menu-props="{ bottom: true, offsetY: true }"
                    item-text="label"
                    item-value="id"
                    return-object
                    ref="refMeetingType"
                    id="meetingType"
                    outlined
                    :no-data-text="noMeetingTypeMsg"
                    hide-details=""
                  >
                    <template v-slot:selection="data">
                      <a-chip
                        v-bind="data.attrs"
                        outlined
                        class="my-1"
                        label
                        small
                        :input-value="data.selected"
                        color="secondary darken-3"
                        close
                        dark
                        @click:close="remove(data.item)"
                        >{{ data.item.label }}</a-chip
                      >
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-row no-gutters>
                <v-col cols="3" class="text-right mr-2"> </v-col>
                <v-col cols="8">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-checkbox
                          v-model="topicFilterForm.fetchAnonymous"
                          :label="`${$t('statistics.lblAnonymousRespondents')}`"
                          dense
                          hide-details
                          class="mt-0 pt-0"
                          :ripple="false"
                        ></v-checkbox>
                      </span>
                    </template>
                    <span>{{ $t("statistics.lblAnonymousRespondents") }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-row no-gutters>
                <v-col cols="3" class="text-right mr-2"> </v-col>
                <v-col cols="8">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-checkbox
                          v-model="topicFilterForm.fetchAllRespondents"
                          :label="$t('statistics.lblNamedRespondents')"
                          dense
                          hide-details
                          class="mt-0 pt-0"
                          :ripple="false"
                          @change="onAllUserChange"
                        ></v-checkbox>
                      </span>
                    </template>
                    <span>{{ $t("statistics.lblNamedRespondents") }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters>
                <v-col cols="3" class="text-right mr-3 mt-2">
                  {{ $t("statistics.lblNamedRespondents") }}:
                </v-col>
                <v-col cols="8">
                  <v-combobox
                    v-model="topicFilterForm.selectedEmail"
                    :items="users"
                    :filter="filter"
                    :search-input.sync="resultSearch"
                    ref="combobox"
                    class="searchComboBox"
                    id="searchComboBox"
                    :label="$t('statistics.lblAll')"
                    :placeholder="$t('statistics.lblAll')"
                    single-line
                    dense
                    clearable
                    chips
                    multiple
                    outlined
                    @input="resultSearch = null"
                    item-text="registered_email"
                    item-value="id"
                    return-object
                    :autocomplete="comboboxAutoSuggest"
                    @focus="comboboxAutoSuggest = 'on'"
                    @blur="comboboxAutoSuggest = 'none'"
                    :no-data-text="$t('noData')"
                    hide-details=""
                    :disabled="!topicFilterForm.fetchAllRespondents"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ $t("noData") }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="data">
                      <v-chip
                        small
                        :key="JSON.stringify(data.item)"
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        :disabled="data.disabled"
                        @click:close="data.parent.selectItem(data.item)"
                        close
                        color="secondary darken-3"
                        class="ma-1 pl-2"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-avatar
                              v-if="data.item.registered_email"
                              left
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-img
                                v-if="data.item.profilePhoto"
                                contain
                                :src="data.item.profilePhoto"
                              ></v-img>
                              <v-img
                                v-else
                                contain
                                src="@/assets/images/NoPhotoIcon.png"
                              ></v-img>
                            </v-avatar>
                            <span
                              v-if="data.item.firstName"
                              v-bind="attrs"
                              v-on="on"
                            >
                              {{
                                data.item.firstName + " " + data.item.lastName
                              }}
                            </span>
                            <span v-else v-bind="attrs" v-on="on">
                              {{ data.item.registered_email }}</span
                            >
                          </template>
                          <span
                            >{{ $t("lblEmail") }}:
                            {{ data.item.registered_email }}</span
                          >
                        </v-tooltip>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list color="#FFF" class="combo-list ma-0 pa-0">
                        <v-list-item
                          v-if="
                            Boolean(item.is_registered_user) &&
                            item.registered_email
                          "
                          :class="[
                            itemSelected(item.registered_email)
                              ? 'selected-removed'
                              : '',
                          ]"
                          @click.stop.prevent="selectEmail(item)"
                        >
                          <v-list-item-avatar class="mt-0 mb-0 mr-2" size="40">
                            <v-img
                              v-if="item.profilePhoto"
                              contain
                              :src="item.profilePhoto"
                            ></v-img>
                            <v-img
                              v-else
                              contain
                              src="@/assets/images/NoPhotoIcon.png"
                            ></v-img>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title>
                              <label>
                                <span v-if="item.firstName">
                                  {{ item.firstName + " " + item.lastName }}
                                </span>
                                <span v-else>{{
                                  item.display_email
                                    ? item.display_email
                                    : item.registered_email
                                }}</span>
                              </label>
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="item.firstName">
                              <label>
                                {{
                                  item.display_email
                                    ? item.display_email
                                    : item.registered_email
                                }}
                              </label>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-avatar
                            class="mt-0 mb-0 mr-2"
                            size="40"
                            v-if="itemSelected(item.registered_email)"
                          >
                            <v-icon color="green" left>mdi-check </v-icon>
                          </v-list-item-avatar>
                          <v-list-item-action style="flex-direction: inherit">
                            <v-btn
                              outlined
                              x-small
                              color="primaryDark"
                              v-if="
                                item.is_registered_user === true &&
                                item.registered_email
                              "
                            >
                              {{ $t("admin.lblRegistered") }}
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-combobox>
                </v-col>
              </v-row>
            </v-col>
          </v-form>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              class="mr-2 primaryDark"
              @click="onSave()"
              :disabled="isFeedbackFilterValidate"
              >{{ $t("btnOk") }}</a-btn
            >
          </template>
          <span>{{ $t("btnOk") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              class="secondary"
              @click="close()"
              >{{ $t("btnLabelCancel") }}</a-btn
            >
          </template>
          <span>{{ $t("btnLabelCancel") }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </a-dialog>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { formatDate } from "@/utils/util";
Vue.use(DatePickerPlugin);
export default {
  name: "FeedbackMeetingFilter",
  data() {
    return {
      noMeetingTypeMsg: this.$t("noData"),
      calmenu: false,
      calmenu2: false,
      validDate: true,
      comboboxAutoSuggest: "none",
      resultSearch: null,
      meetingObject: this.selectedMeeting,
      topicFilterForm: {
        meetingType: [],
        startDate: new Date().toISOString().slice(0, 10),
        endDate: new Date().toISOString().slice(0, 10),
        selectedEmail: [],
        fetchAnonymous: false,
        fetchAllRespondents: true,
      },
      isValidEndDate: false,
      emailRules: [
        (v) => !!(v && this.emailRequired(v)) || this.$t("ruleEmailReq"),
      ],
      startDateRule: [(v) => !!v || this.$t("lblSelectDate")],
      endDateRule: [(v) => !!v || this.$t("lblSelectDate")],
      filterPayload: null,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    const savedFilters = sessionStorage.getItem("TopicFeedbackFilterInputs");

    if (!savedFilters || !this.userList.length) return;

    const filterData = JSON.parse(savedFilters);
    if (filterData) {
      const {
        start_date,
        end_date,
        user_ids = [],
        meeting_type_ids = [],
        fetch_anonymous,
        fetchAllRespondents,
      } = filterData;

      this.topicFilterForm.startDate = start_date;
      this.topicFilterForm.endDate = end_date;
      this.topicFilterForm.fetchAnonymous = fetch_anonymous;
      this.topicFilterForm.fetchAllRespondents = fetchAllRespondents;

      this.topicFilterForm.selectedEmail = this.userList.filter((user) =>
        user_ids.includes(user.id)
      );

      this.topicFilterForm.meetingType = this.meetingTypes.filter((type) =>
        meeting_type_ids.includes(type.id)
      );
    }
  },
  methods: {
    ...mapActions({
      getStatisticsData: "admin/getStatisticsData",
    }),
    formatDate,
    selectEmail(item) {
      const index = this.topicFilterForm.selectedEmail.findIndex(
        (selected) => selected.id === item.id
      );

      index !== -1
        ? this.topicFilterForm.selectedEmail.splice(index, 1)
        : this.topicFilterForm.selectedEmail.push(item);
    },
    close() {
      this.$refs.refAttendanceForm.resetValidation();
      this.isOpen = false;
    },
    async onSave() {
      if (this.$refs.refAttendanceForm.validate()) {
        let userIds = this.topicFilterForm.selectedEmail.map((obj) => {
          return obj.id;
        });
        const data = {
          start_date: this.topicFilterForm.startDate,
          end_date: this.topicFilterForm.endDate,
          meeting_type_ids: this.topicFilterForm.meetingType.map((m) => m.id),
          user_ids: userIds,
          fetch_anonymous: this.topicFilterForm.fetchAnonymous,
          fetchAllRespondents: this.topicFilterForm.fetchAllRespondents,
        };

        sessionStorage.setItem(
          "TopicFeedbackFilterInputs",
          JSON.stringify(data)
        );

        this.$emit("feedbackFilterPayload", data);
        if (this.$route.path !== "/statistics&analysis/topic-feedback") {
          this.$router.push({ path: "/statistics&analysis/topic-feedback" });
        } else {
          this.close();
        }
      }
    },
    filter(item, queryText) {
      const hasValue = (val) => (val != null ? val : "");
      const query = hasValue(queryText);
      return (
        (item.firstName &&
          item.firstName
            .toLowerCase()
            .indexOf(query.toString().toLowerCase()) !== -1) ||
        (item.lastName &&
          item.lastName
            .toLowerCase()
            .indexOf(query.toString().toLowerCase()) !== -1) ||
        (item.contactEmailIds &&
          item.contactEmailIds.filter(
            (email) =>
              email &&
              email.toLowerCase().indexOf(query.toString().toLowerCase()) !== -1
          ).length > 0)
      );
    },
    itemSelected(itemEmail) {
      const selectedIndex =
        this.topicFilterForm.selectedEmail &&
        this.topicFilterForm.selectedEmail.length > 0
          ? this.topicFilterForm.selectedEmail.findIndex(
              (attendee) => attendee.registered_email === itemEmail
            )
          : -1;
      return selectedIndex !== -1;
    },
    emailRequired(data) {
      return data.length;
    },
    remove(item) {
      const index = this.topicFilterForm.meetingType
        .map((e) => e.id)
        .indexOf(item.id);
      if (index >= 0) this.topicFilterForm.meetingType.splice(index, 1);
    },
    onAllUserChange(value) {
      if (!value) {
        this.topicFilterForm.selectedEmail = [];
      }
    },
  },
  watch: {
    "topicFilterForm.selectedEmail"(val) {
      let entry =
        this.topicFilterForm.selectedEmail[
          this.topicFilterForm.selectedEmail.length - 1
        ];
      if (entry && typeof entry !== "object") {
        let index = this.topicFilterForm.selectedEmail.indexOf(entry);
        if (index > -1) {
          this.topicFilterForm.selectedEmail.splice(index, 1);
        }
      }
    },
    "topicFilterForm.startDate": {
      immediate: true,
      handler(date) {
        if (
          date > this.topicFilterForm.endDate &&
          this.topicFilterForm.endDate != ""
        ) {
          this.topicFilterForm.endDate = this.currentDate;
        }
      },
    },
    "topicFilterForm.endDate": {
      immediate: true,
      handler(endDate) {
        if (endDate === null || this.topicFilterForm.endDate == "") {
          this.isValidEndDate = true;
        } else this.isValidEndDate = false;
      },
    },
  },
  computed: {
    ...gettersMap(),
    ...mapState({
      userList: (state) => state.people.userList,
    }),
    dateFormat() {
      return this.selectedLang !== "ja" ? "dd-MM-yyyy" : "yyyy-MM-dd";
    },
    formatStartDate: {
      get() {
        return this.formatDate(
          new Date(this.topicFilterForm.startDate),
          this.dateFormat
        );
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
    formatEndDate: {
      get() {
        return this.formatDate(
          new Date(this.topicFilterForm.endDate),
          this.dateFormat
        );
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    isOpen: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    users() {
      return this.userList.filter(
        (user) => Boolean(user.is_registered_user) && user.registered_email
      );
    },
    loaderText() {
      return this.$t("LoaderText");
    },
    currentDate() {
      return new Date().toISOString().slice(0, 10);
    },
    meetingTypesList() {
      if (!Array.isArray(this.meetingTypes) || this.meetingTypes.length === 0) {
        this.noMeetingTypeMsg = this.$t("noData");
        return [];
      }

      const filteredList = this.meetingTypes.filter((item) =>
        this.$security.checkMeetingTypeAccess(item.id, "ViewMeeting")
      );

      this.noMeetingTypeMsg = filteredList.length
        ? ""
        : this.$t("noMeetingTypeData");

      return filteredList;
    },
    isFeedbackFilterValidate() {
      return !(
        this.topicFilterForm.fetchAnonymous ||
        this.topicFilterForm.fetchAllRespondents
      );
    },
  },
};
function gettersMap() {
  return mapGetters({
    meetingTypes: "tenant/agendaMeetingTypes",
  });
}
</script>

<style scoped>
.searchComboBox /deep/ .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
}
.v-list-item:has(.combo-list) {
  margin: 0px !important;
  padding: 0px !important;
}
.combo-list {
  width: 100%;
}
.combo-list .v-list-item {
  width: 100%;
  cursor: pointer;
}
.combo-list .v-list-item:hover {
  background-color: #e6e6e6 !important;
}
.combo-list .v-list-item.selected {
  background-color: paleturquoise !important;
}
.combo-list .v-list-item label {
  cursor: pointer;
}
::v-deep .e-date-wrapper {
  border: 1px solid gray !important;
  border-radius: 4px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
  height: 40px;
  font-size: 15px !important;
}

::v-deep .e-date-wrapper .e-input-group-icon {
  min-height: 18px !important;
  min-width: 18px !important;
}
.selectField /deep/ .v-label {
  line-height: 19px !important;
}
.selectField /deep/ .v-select__selections {
  line-height: 21px !important;
}
</style>